var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bg-white",
      style: _vm.getStyle,
      attrs: { id: "employeesCreatedByUserCard" },
    },
    [
      _c(
        "vx-card",
        [
          _c("h2", { staticClass: "mb-2" }, [
            _vm._v("\n      Mes dernières personnes créées\n    "),
          ]),
          _vm._v(" "),
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                {
                  attrs: {
                    "vs-type": "flex",
                    "vs-justify": "center",
                    "vs-align": "center",
                    "vs-w": "12",
                  },
                },
                [
                  _c(
                    "DialogPrompt",
                    {
                      attrs: {
                        active: _vm.showPopup,
                        title: "Consulter une personne",
                        "cancel-text": "Fermer",
                        "accept-text": "Enregistrer",
                        "button-accept": "false",
                      },
                      on: {
                        "update:active": function ($event) {
                          _vm.showPopup = $event
                        },
                      },
                    },
                    [
                      _c("EmployeeForm", {
                        attrs: { type: "show" },
                        model: {
                          value: _vm.resource,
                          callback: function ($$v) {
                            _vm.resource = $$v
                          },
                          expression: "resource",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "vs-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        sst: true,
                        "no-data-text": "Aucune donnée à afficher",
                        data: _vm.persons,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ data }) {
                            return _vm._l(_vm.persons, function (item, i) {
                              return _c(
                                "vs-tr",
                                { key: i, attrs: { data: item } },
                                [
                                  _c(
                                    "vs-td",
                                    [
                                      _vm.get(item, ":photoUrl")
                                        ? _c("vs-avatar", {
                                            attrs: {
                                              size: "30px",
                                              src: _vm.get(item, ":photoUrl"),
                                            },
                                          })
                                        : _c("vs-avatar", {
                                            attrs: {
                                              size: "30px",
                                              color: _vm.generateColor(
                                                item.name
                                              ),
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "vs-td",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: {
                                            content: item.description,
                                            placement: "top-start",
                                            classes: ["occ-description"],
                                          },
                                          expression:
                                            "{\n                              content: item.description,\n                              placement: 'top-start',\n                              classes: ['occ-description']\n                          }",
                                        },
                                      ],
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticStyle: {
                                            color: "rgb(98, 98, 98)",
                                          },
                                          attrs: {
                                            href:
                                              "/rh/gestion/personnes/" +
                                              _vm.get(item, ":id") +
                                              "/parcours",
                                          },
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.get(item, ":last_name")
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("vs-td", [
                                    _c(
                                      "a",
                                      {
                                        staticStyle: {
                                          color: "rgb(98, 98, 98)",
                                        },
                                        attrs: {
                                          href:
                                            "/rh/gestion/personnes/" +
                                            _vm.get(item, ":id") +
                                            "/parcours",
                                        },
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "<" +
                                              _vm._s(
                                                _vm.get(item, ":first_name")
                                              )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("vs-td", [
                                    _c(
                                      "a",
                                      {
                                        staticStyle: {
                                          color: "rgb(98, 98, 98)",
                                        },
                                        attrs: {
                                          href:
                                            "/rh/gestion/personnes/" +
                                            _vm.get(item, ":id") +
                                            "/parcours",
                                        },
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm
                                                .get(item, ":services")
                                                .map((s) => s.title)
                                                .join(", ")
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("vs-td", [
                                    _c(
                                      "a",
                                      {
                                        staticStyle: {
                                          color: "rgb(98, 98, 98)",
                                        },
                                        attrs: {
                                          href:
                                            "/rh/gestion/personnes/" +
                                            _vm.get(item, ":id") +
                                            "/parcours",
                                        },
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm
                                                .get(item, ":services")
                                                .map(
                                                  (s) => s.establishment.name
                                                )
                                                .join(", ")
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              )
                            })
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "template",
                        { slot: "thead" },
                        [
                          _c("vs-th"),
                          _vm._v(" "),
                          _c("vs-th", [_vm._v("Nom")]),
                          _vm._v(" "),
                          _c("vs-th", [_vm._v("Prénom")]),
                          _vm._v(" "),
                          _c("vs-th", [_vm._v("Service")]),
                          _vm._v(" "),
                          _c("vs-th", [_vm._v("Etablissement")]),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }